import { ChatMessage } from "../types/Chatbot/Chat";

export function transformChatDataToMessage(data: any): ChatMessage {
  console.log("transformChatDataToMessage data", data);

  const parsed = JSON.parse(data?.chatData?.data?.response || "{}");
  const answerText = parsed.answer;

  const isRelatedMatch = answerText.match(/query_is_related:\s*(true|false)/);
  const isRelated = isRelatedMatch ? isRelatedMatch[1] === "true" : null;

  const message = answerText.split("\n\n")[1];
  console.log("Parsed message:", message);

  if (isRelated === false) {
    return {
      question: data?.fullData?.data?.query || "Unknown question",
      summary: message || "I'm sorry, I couldn't find relevant information to answer your question.",
      explanation: "",
      sources: [],
    };
  }

  // Parse the response field to extract its content
  let parsedResponse: { answer: string; references: any[] } = {
    answer: "",
    references: [],
  };

  try {
    parsedResponse = JSON.parse(data?.fullData?.data?.response || "{}");
  } catch (error) {
    console.error("Error parsing response:", error);
  }

  // Helper to sanitize text and remove trailing commas
  const sanitizeText = (text: string): string =>
    text
      .replace(/summary:|explanation:|{|}|"/g, "") // Remove unwanted labels and characters
      .replace(/,$/, "") // Remove trailing commas
      .trim();

  // Determine `summary` and `explanation` based on content
  let summary = "";
  let explanation = "";

  if (parsedResponse.answer) {
    const cleanedAnswer = sanitizeText(parsedResponse.answer);

    // Extract and split into summary and explanation if labeled
    if (cleanedAnswer.includes("summary:") || cleanedAnswer.includes("explanation:")) {
      const summaryMatch = cleanedAnswer.match(/summary:(.*?)(?=explanation:|$)/);
      const explanationMatch = cleanedAnswer.match(/explanation:(.*)/);

      summary = summaryMatch ? sanitizeText(summaryMatch[1]) : "";
      explanation = explanationMatch ? sanitizeText(explanationMatch[1]) : "";
    } else {
      // If no labels, put the whole text in summary
      summary = cleanedAnswer;
    }
  }

  // Extract sources as links from references
  const sources = parsedResponse.references.map((ref: any) => ref?.Meta?.source || ref?.Table?.sources?.[0]).filter(Boolean);

  return {
    question: data?.data?.query || "Unknown question",
    summary,
    explanation,
    sources,
  };
}
